//messages.js
export default {
    account_id: "Account ID",
    account_number: "Account Number",
    account_name: "Account Name",
    bank_name: "Bank Name",
    branch_name: "Branch Name",
    account_type: "Account Type",
    routing_number: "Routing Number",
    currency_id: "Currency",
    balance: "Balance",
    is_active: "Active",
    edit_bank_account: "Edit Bank Account",
    add_bank_account: "Add Bank Account",
    delete_bank_account: "Delete Bank Account",
    bank_accounts: "Bank Accounts",
};
